<div class="custom-mat-form-wrapper">
  <div class="mat-form-label" *ngIf="label">
    <ng-container *ngIf="state.labelTemplate; else defaultLabelTmpl">
      <ng-container *ngTemplateOutlet="state.labelTemplate"></ng-container>
    </ng-container>

    <ng-template #defaultLabelTmpl>
      <span>{{ label }}</span>
      <y42-icon *ngIf="tooltipHint" [icon]="'circle-info'" [matTooltip]="tooltipHint"></y42-icon>
    </ng-template>
  </div>

  <mat-form-field class="w-full" appearance="fill" subscriptSizing="dynamic" [color]="color">
    <mat-select
      [formControl]="formCtrl"
      [placeholder]="placeholder ?? ''"
      [multiple]="_multiple"
      [hideSingleSelectionIndicator]="hideSingleSelectionIndicator"
      panelClass="custom-mat-select-panel"
      data-test="select"
    >
      <mat-option
        *ngFor="let option of state.options; trackBy: trackBy"
        [value]="option.value"
        [attr.data-test]="'option-value-' + option.value"
      >
        <ng-container *ngIf="optionTmpl; else defaultOptionTmpl">
          <ng-container
            *ngTemplateOutlet="optionTmpl.templateRef; context: { $implicit: option.option }"
          ></ng-container>
        </ng-container>
        <ng-template #defaultOptionTmpl>
          {{ option.label }}
        </ng-template>
      </mat-option>
    </mat-select>

    <ng-content></ng-content>

    <mat-error *ngIf="!hideErrors">
      <ng-container *ngIf="state.errorMessage">
        {{ state.errorMessage }}
      </ng-container>
    </mat-error>
  </mat-form-field>
</div>
